<div class="success-dialog">
  <div>
    <div class="icon-container">
      <img src="assets/icon/pin-successfull.svg" alt="Success Icon" class="success-icon" />
    </div>
    <div class="title-wrap">
      <h2>{{ title }}</h2>
      <pre [innerHTML]="body"></pre>
    </div>
    <lib-button
      (click)="close()"
      [label]="closeText"
      [width]="'100%'"
      style="width: 100%"
    ></lib-button>
  </div>
</div>
